var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chart-styles" },
    [
      _c(
        "div",
        { staticClass: "c-s-t" },
        [
          _vm._v("\n    Y轴坐标\n    "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                content: "百分比堆积柱状图不可设置",
                placement: "top",
              },
            },
            [
              _c(
                "span",
                { staticClass: "question-icon" },
                [
                  _c(
                    "el-icon",
                    { attrs: { size: "16" } },
                    [_c("ElIconQuestionFilled")],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "最大值" } },
        [
          _c("el-input-number", {
            staticStyle: { width: "100%" },
            attrs: {
              disabled: _vm.option.chartStyle == 3,
              min: _vm.option.axisCoordinates.min,
            },
            model: {
              value: _vm.option.axisCoordinates.max,
              callback: function ($$v) {
                _vm.$set(_vm.option.axisCoordinates, "max", $$v)
              },
              expression: "option.axisCoordinates.max",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "最小值" } },
        [
          _c("el-input-number", {
            staticStyle: { width: "100%" },
            attrs: {
              disabled: _vm.option.chartStyle == 3,
              min: 0,
              max: _vm.option.axisCoordinates.max,
            },
            model: {
              value: _vm.option.axisCoordinates.min,
              callback: function ($$v) {
                _vm.$set(_vm.option.axisCoordinates, "min", $$v)
              },
              expression: "option.axisCoordinates.min",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }